import { isMobile, isTablet } from "react-device-detect";
import { DEVICE } from "./protocolEnums";

/**
 * The `group.devices` value this browser counts as, for protocol matching.
 *
 * Desktop answers null — "no device filter" — so desktop keeps matching every
 * group exactly as it did before devices were consulted at all; the number of
 * displays isn't known here to pick between the DESKTOP_n values anyway.
 * Mobile and tablet answer their own value, so a group an admin has scoped to
 * desktop displays stays off the phone.
 */
export function currentHpDevice() {
  if (!isMobile) return null;
  return isTablet ? DEVICE.TABLET : DEVICE.MOBILE;
}
